<template>
	<section>
		<div class="page__title page__title--with-buttons">
			<h1>
				<img src="/img/payment/share-space-icon.svg" alt="" />  de cours
			</h1>
			<div class="button__container">
				<router-link class="button button--secondary" :to="{name:'MyResourcesAddQuestion'}">✏️ Créer une Séquence</router-link>
			</div>
		</div>
		<p class="page__description">Vous trouverez dans cet espace des ressources partagées par la communauté d'enseignant. Vous pouvez également partager vos propres ressources.</p>
		<a class="page__open-info" @click="isPopUpFlashVisible = !isPopUpFlashVisible"></a>
		<div class="link-container">
			<div class="link-wrapper">
				<router-link to="#" id="all">Toutes les </router-link>
				<span class="underline" :style="'width:' + spanWidth + 'px;left:' + spanPosition + 'px;'"></span>
			</div>
		</div>
		<div class="all-filter-container">
			<form class="filter-desc-title">
				<img
					class="magnifying-glass"
					src="/img/magnifying-glass.svg"
					alt="" />
				<input
					class="search-input"
					type="text"
					placeholder="Rechercher par mots clefs" />
			</form>
			<div class="all-filter-wrapper">
				<div class="filter-wrapper my-content">
					<select name="subject" id="subject"><option value=""> Toutes les matières </option><option value="1">Maths</option><option value="27">Français</option><option value="28">Histoire-géographie</option><option value="29">SVT</option><option value="30">Physique-chimie</option><option value="31">Anglais</option><option value="32">Espagnol</option><option value="33">Allemand</option><option value="34">Technologie</option><option value="35">SES</option><option value="36">SNT</option><option value="37">HGGSP</option><option value="38">HLP</option><option value="39">LLCE</option><option value="40">NSI</option><option value="41">SI</option><option value="42">LCA</option><option value="43">Economie Gestion</option><option value="45">Economie Droit</option><option value="46">Philosophie</option><option value="47">Biologie</option><option value="48">Prévention Santé Environnement</option><option value="49">Education musicale</option><option value="50">Arts plastiques</option><option value="51">EMI</option></select></div><div class="filter-wrapper">
					<select name="level" id="level" placeholder="Sélectionner un niveau"><option value=""> Tous les niveaux </option><option value="1">6ème</option><option value="2">5ème</option><option value="3">4ème</option><option value="4">3ème</option><option value="5">2nde</option><option value="6">1ère</option><option value="7">Term</option><option value="15">1ère Techno</option><option value="17">Term Techno</option><option value="13">CAP</option><option value="11">1ère BAC Pro</option><option value="10">2nde BAC Pro</option><option value="12">Term BAC Pro</option><option value="21">BAC+1</option></select></div><div class="filter-wrapper">
					<select class="filter-chapter" name="chapter" id="chapter"><option value=""> Tous les chapitres </option></select></div>
				</div>
			</div>
	</section>
</template>

<script>
// import NoContent from '../../../Search/NoContent.vue'

export default {
	components:{
		// NoContent
	},
	data() {
		return {
			spanWidth: 0,
			spanPosition: 0,
		}
	},
	mounted () {
    const question = document.getElementById('all')

    this.spanWidth = question.offsetWidth

    const parentLeft = question.parentNode.getBoundingClientRect().left
    this.spanPosition = question.getBoundingClientRect().left - parentLeft
  },

  watch: {
    '$route'() {
      const question = document.getElementById('all')
      this.spanWidth = question.offsetWidth
      const parentLeft = question.parentNode.getBoundingClientRect().left
      this.spanPosition = question.getBoundingClientRect().left - parentLeft
    }
  }
	
}
</script>
